import React from 'react';

export default function CowboyBoot({ className = "w-6 h-6", ...props }) {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="currentColor"
      className={className}
      {...props}
    >
      {/* Classic cowboy boot with distinct heel, shaft and pointed toe */}
      <path d="M9 1C8.4 1 8 1.4 8 2V7H6C5.4 7 5 7.4 5 8V10H3C2.4 10 2 10.4 2 11V14C2 14.6 2.4 15 3 15H5V18H4C3.4 18 3 18.4 3 19V22C3 22.6 3.4 23 4 23H8C8.6 23 9 22.6 9 22V20H22C22.6 20 23 19.6 23 19V17C23 16.4 22.6 16 22 16H10V15H11C11.6 15 12 14.6 12 14V10H13C13.6 10 14 9.6 14 9V8C14 7.4 13.6 7 13 7H11V2C11 1.4 10.6 1 10 1H9Z" />
    </svg>
  );
}
